import DiligenceReportPage, {
  diligenceReportQuery,
} from "@app/pages/diligence/diligence-report-page";
import type { diligenceReportPage_Query } from "@app/queries/diligenceReportPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/diligence_/report")({
  // network-only: arriving here straight after pressing Generate must show the
  // run that was just queued, not a store snapshot from before it.
  loader: () =>
    loadQuery<diligenceReportPage_Query>(
      environment,
      diligenceReportQuery,
      {},
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Diligence report"),
  component: DiligenceReportRoute,
});

function DiligenceReportRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading the report page</div>
      }
    >
      <Suspense fallback={<div className="p-6 text-gray-500">Loading…</div>}>
        <DiligenceReportPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
